import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $integrationsStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { IntegrationList } from './widgets';
import { PageContainer, View } from '@widgets';

export const IntegrationsPage = () => {
  const { navigate } = useRouteHook();

  const integrationsStore = useUnit($integrationsStore.store);

  const { t } = useTranslation('integrations');

  useEffect(() => {
    if (PaletteUtils.isPersonalPalette) {
      navigate(RoutePaths.dashboard.onNavigate());
      return;
    }

    $integrationsStore.events.getInitialIntegrations();
    return () => $integrationsStore.events.clear();
  }, []);

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <View
        loading={integrationsStore.loading}
        error={integrationsStore.error}
        noData={!integrationsStore.data.length}
        onRefresh={() => $integrationsStore.events.getInitialIntegrations()}
      >
        <IntegrationList list={integrationsStore.data} />
      </View>
    </PageContainer>
  );
};
